import { render, staticRenderFns } from "./EmailPreview.vue?vue&type=template&id=4b0fd925&scoped=true"
import script from "./EmailPreview.vue?vue&type=script&lang=ts"
export * from "./EmailPreview.vue?vue&type=script&lang=ts"
import style0 from "./EmailPreview.vue?vue&type=style&index=0&id=4b0fd925&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0fd925",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b0fd925')) {
      api.createRecord('4b0fd925', component.options)
    } else {
      api.reload('4b0fd925', component.options)
    }
    module.hot.accept("./EmailPreview.vue?vue&type=template&id=4b0fd925&scoped=true", function () {
      api.rerender('4b0fd925', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inbox/EmailPreview.vue"
export default component.exports